import { useState } from "react";
import { useForm } from "react-hook-form";
import { IconX } from "@tabler/icons-react";
import toast from "react-hot-toast";

import AddMerchantModal from "./AddMerchantModal";
import { useMerchantCreateMutation } from "../../../apis/merchantApis";
import { useLanguage } from "../../../context/LanguageContext";

interface Props {
  onClose: () => void;
  refetch?: () => void;
}

export default function AddMerchantSidebar({ onClose, refetch }: Props) {
  const { t } = useLanguage();
  const [allIds, setAllIds] = useState<any>();

  const { mutate, isPending } = useMerchantCreateMutation();

  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm<any>();

  const getIds = (data: any) => {
    setAllIds(data);
  };

  const handleCreate = (data: any) => {
    mutate(
      {
        ...data,
        ...allIds,
      },
      {
        onSuccess: () => {
          toast.success(t("Merchant Added Successfully"));

          reset();

          refetch?.();

          onClose();
        },
        onError: (error: any) => {
          const errorMessage =
            error?.response?.data?.error?.message ||
            error?.response?.data?.message ||
            error?.message ||
            "Something went wrong";

          toast.error(t(errorMessage));
        },
      },
    );
  };

  return (
    <div className="relative bg-white  rounded-3xl shadow-sm border flex flex-col overflow-hidden">
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 ">
        <h2 className="text-xl font-semibold text-[#212121]">{t("Add Merchant")}</h2>

        <div className="flex items-center gap-3">
          <button
            onClick={handleSubmit(handleCreate)}
            disabled={isPending}
            className="px-4 py-2 bg-[#FBD037] text-[#212121] rounded-lg disabled:opacity-50"
          >
            {isPending ? t("Adding...") : t("Add")}
          </button>

          <button
            onClick={onClose}
            className="p-2 rounded-lg border border-[#D2D2D2]"
          >
            <IconX size={20} />
          </button>
        </div>
      </div>

      <AddMerchantModal
        register={register}
        errors={errors}
        clearErrors={clearErrors}
        setValue={setValue}
        control={control}
        getIds={getIds}
        watch={watch}
      />
    </div>
  );
}
